import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import Angela1C from "../Common/Angela/Angela1C";
import ZenDonut from "../Common/Graph/ZenDonut";
import ZenVerStackBar from "../Common/Graph/ZenVerStackBar";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenClusterColVer from "../Common/Graph/ZenClusterColVer";

import ZenSpectrum from "../Common/Graph/ZenSpectrum";
import ZenPareto from "../Common/Graph/ZenPareto";
import ZenVerCandleStick from "../Common/Graph/ZenVerCandleStick";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ClassChartGrpTest extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    Snippet1LinePe: null,
    Snippet1LineTimeDist: null,
    Snippet1LinePeLossTimeDist: null,
    Snippet1LinePeLossShiftWise: null,
    Snippet1LinePeSpectrumTimeDist: null,
    Snippet1LinePePartWisePeDist: null,
    Snippet1LinePePartWiseTimeDist: null,
    Snippet1LinePePartwiseCtDist: null,
    ZenVerBarMonthlyDailyTrend: null,
    VerClusterShiftWiseTrend: null,
    dataLoading: false,
    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("PE Analytics");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab = "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/chartsnippetpe", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "Snippet1LinePE",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["Snippet1LinePe"] = resp["data"]["Snippet1LinePe"];
        respData["Snippet1LineTimeDist"] = resp["data"]["Snippet1LineTimeDist"];
        respData["Snippet1LinePeLossTimeDist"] =
          resp["data"]["Snippet1LinePeLossTimeDist"];
        respData["Snippet1LinePeLossShiftWise"] =
          resp["data"]["Snippet1LinePeLossShiftWise"];
        respData["Snippet1LinePeSpectrumTimeDist"] =
          resp["data"]["Snippet1LinePeSpectrumTimeDist"];
        respData["Snippet1LinePePartWisePeDist"] =
          resp["data"]["Snippet1LinePePartWisePeDist"];
        respData["Snippet1LinePePartWiseTimeDist"] =
          resp["data"]["Snippet1LinePePartWiseTimeDist"];
        respData["Snippet1LinePePartwiseCtDist"] =
          resp["data"]["Snippet1LinePePartwiseCtDist"];
          respData["ZenVerBarMonthlyDailyTrend"] =
          resp["data"]["ZenVerBarMonthlyDailyTrend"];
        respData["VerClusterShiftWiseTrend"] =
          resp["data"]["VerClusterShiftWiseTrend"];
        respData["VerBarHourlyTrend"] = resp["data"]["VerBarHourlyTrend"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        Performance Efficiency Analytics
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                      {/* _______Row No 1________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Snippet1LinePe"}
                              data={this.state.Snippet1LinePe.data}
                              config={this.state.Snippet1LinePe.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenDonut
                              divId={"Snippet1LineTimeDist"}
                              data={this.state.Snippet1LineTimeDist.data}
                              config={this.state.Snippet1LineTimeDist.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenDonut
                              divId={"Snippet1LinePeLossTimeDist"}
                              data={this.state.Snippet1LinePeLossTimeDist.data}
                              config={
                                this.state.Snippet1LinePeLossTimeDist.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "30%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerStackBar
                              divId={"Snippet1LinePeLossShiftWise"}
                              data={this.state.Snippet1LinePeLossShiftWise.data}
                              config={
                                this.state.Snippet1LinePeLossShiftWise.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "50%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ZenVerBarMonthlyDailyTrend"}
                              data={this.state.ZenVerBarMonthlyDailyTrend.data}
                              config={
                                this.state.ZenVerBarMonthlyDailyTrend.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenClusterColVer
                              divId={"VerClusterShiftWiseTrend"}
                              data={this.state.VerClusterShiftWiseTrend.data}
                              config={
                                this.state.VerClusterShiftWiseTrend.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "25%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"VerBarHourlyTrend"}
                              data={this.state.VerBarHourlyTrend.data}
                              config={this.state.VerBarHourlyTrend.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 2________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "100%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenSpectrum
                              divId={"Snippet1LinePeSpectrumTimeDist"}
                              data={
                                this.state.Snippet1LinePeSpectrumTimeDist.data
                              }
                              config={
                                this.state.Snippet1LinePeSpectrumTimeDist.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 3________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "33%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenPareto
                              divId={"Snippet1LinePePartWisePeDist"}
                              data={
                                this.state.Snippet1LinePePartWisePeDist.data
                              }
                              config={
                                this.state.Snippet1LinePePartWisePeDist.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "33%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerStackBar
                              divId={"Snippet1LinePePartWiseTimeDist"}
                              data={
                                this.state.Snippet1LinePePartWiseTimeDist.data
                              }
                              config={
                                this.state.Snippet1LinePePartWiseTimeDist.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "34%" }}>
                          {/* <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerCandleStick
                              divId={"Snippet1LinePePartwiseCtDist"}
                              data={
                                this.state.Snippet1LinePePartwiseCtDist.data
                              }
                              config={
                                this.state.Snippet1LinePePartwiseCtDist.config
                              }
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div> */}
                        </Col>
                      </Row>

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ClassChartGrpTest;
